import { Flex, Grid, Typography } from '@aloft/toolkit-sui';

import { PropsWithChildren } from 'react';

const MLSDataInfoSection = ({
  children,
  title,
  spanColumns = false,
}: PropsWithChildren<{ title: string; spanColumns?: boolean }>) => (
  <Flex flexDirection="column" marginTop="1.25rem">
    <Typography variant="h2">{title}</Typography>
    <Grid
      width="100%"
      justifyContent="space-between"
      columnGap="2rem"
      gridTemplateColumns={spanColumns ? '1fr' : '1fr 1fr'}
    >
      {children}
    </Grid>
  </Flex>
);

export default MLSDataInfoSection;
